import BotonManualHeader from "../../components/BotonManualHeader";
import React, { useState, useEffect } from "react";
import { Container, Card, Button, Table, Badge, Alert, Spinner, Row, Col } from "react-bootstrap";
import { FaClock, FaSync, FaHistory, FaCheckCircle, FaTimesCircle, FaCalendarAlt } from "react-icons/fa";
import { getFunctions, httpsCallable } from "firebase/functions";
import firebaseApp from "../../firebase/credenciales";
import Swal from "sweetalert2";

const functions = getFunctions(firebaseApp, "southamerica-east1");

function IncrementoVacaciones({ usuario }) {
    const [loading, setLoading] = useState(false);
    const [loadingHistorial, setLoadingHistorial] = useState(false);
    const [historial, setHistorial] = useState([]);

    useEffect(() => {
        cargarHistorial();
    }, []);

    const cargarHistorial = async () => {
        setLoadingHistorial(true);
        try {
            const obtenerHistorial = httpsCallable(functions, "obtenerHistorialIncrementos");
            const result = await obtenerHistorial({ limite: 10 });

            if (result.data.success) {
                setHistorial(result.data.historial);
            }
        } catch (error) {
            console.error("Error al cargar historial:", error);
            Swal.fire({
                icon: "error",
                title: "Error al Cargar Historial",
                text: error.message,
            });
        } finally {
            setLoadingHistorial(false);
        }
    };

    const ejecutarIncrementoManual = async () => {
        const result = await Swal.fire({
            icon: "warning",
            title: "Confirmar Incremento Manual",
            html: `
        <p>Esta acción incrementará las vacaciones pendientes de <strong>todos los empleados activos</strong>:</p>
        <ul style="text-align: left;">
          <li><strong>Régimen General:</strong> +2.5 días</li>
          <li><strong>Pequeña Empresa:</strong> +1.25 días</li>
        </ul>
        <p><strong>¿Deseas continuar?</strong></p>
      `,
            showCancelButton: true,
            confirmButtonText: "Sí, Ejecutar",
            cancelButtonText: "Cancelar",
        });

        if (!result.isConfirmed) return;

        setLoading(true);

        try {
            const incrementarManual = httpsCallable(functions, "incrementarVacacionesManual");
            const response = await incrementarManual();

            if (response.data.success) {
                await Swal.fire({
                    icon: "success",
                    title: "Incremento Completado",
                    html: `<p><strong>${response.data.exitosos}</strong> registros actualizados</p>`,
                });
                cargarHistorial();
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error al Ejecutar",
                text: error.message,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
                minHeight: "100vh",
                padding: "20px 0",
            }}
        >
            <Container fluid style={{ width: "90%" }}>
                <Card
                    className="shadow-lg border-0"
                    style={{ borderRadius: "15px", overflow: "hidden" }}
                >
                    <Card.Header
                        className="text-white py-4 position-relative"
                        style={{
                            background: "linear-gradient(45deg, #2c3e50, #3498db)",
                            borderBottom: "3px solid #f39c12",
                        }}
                    >
          <div
            className="position-absolute end-0 top-50 translate-middle-y me-4"
            style={{ zIndex: 10 }}
          >
            <BotonManualHeader />
          </div>
                        <h2 className="fw-bold mb-0">
                            <FaClock className="me-3" />
                            Incremento Automático de Vacaciones
                        </h2>
                    </Card.Header>
                    <Card.Body style={{ backgroundColor: "#f8f9fa", padding: "30px" }}>
                        <Alert variant="info" className="mb-4">
                            <h6>🤖 Ejecución Automática</h6>
                            <p>El sistema incrementa automáticamente las vacaciones el primer día de cada mes.</p>
                        </Alert>

                        <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
                            <Card.Header className="bg-warning text-dark">
                                <h5 className="mb-0">
                                    <FaSync className="me-2" />
                                    Ejecución Manual
                                </h5>
                            </Card.Header>
                            <Card.Body>
                                <Button
                                    variant="primary"
                                    size="lg"
                                    onClick={ejecutarIncrementoManual}
                                    disabled={loading}
                                    style={{
                                        borderRadius: "10px",
                                        background: "linear-gradient(45deg, #3498db, #2980b9)",
                                    }}
                                >
                                    {loading ? <Spinner animation="border" size="sm" className="me-2" /> : <FaSync className="me-2" />}
                                    Ejecutar Incremento Manual
                                </Button>
                            </Card.Body>
                        </Card>

                        <Card className="shadow-sm border-0" style={{ borderRadius: "15px" }}>
                            <Card.Header className="bg-primary text-white">
                                <h5 className="mb-0">
                                    <FaHistory className="me-2" />
                                    Historial de Ejecuciones
                                </h5>
                            </Card.Header>
                            <Card.Body>
                                {loadingHistorial ? (
                                    <Spinner animation="border" variant="primary" />
                                ) : (
                                    <Table responsive hover>
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Exitosos</th>
                                                <th>Fallidos</th>
                                                <th>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {historial.map((log) => (
                                                <tr key={log.id}>
                                                    <td>{log.fecha ? new Date(log.fecha).toLocaleString() : "N/A"}</td>
                                                    <td>
                                                        <Badge bg="success">{log.totalExitosos || 0}</Badge>
                                                    </td>
                                                    <td>
                                                        <Badge bg="danger">{log.totalFallidos || 0}</Badge>
                                                    </td>
                                                    <td>
                                                        {log.estado === "ERROR_CRITICO" ? (
                                                            <FaTimesCircle className="text-danger" />
                                                        ) : (
                                                            <FaCheckCircle className="text-success" />
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                )}
                            </Card.Body>
                        </Card>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
}

export default IncrementoVacaciones;
